import { fillHtml } from '../../lib/richText';
import type { MessageVars } from '../whatsapp/messages';

/** Fills an HTML email template's placeholders (escaped); one without a value is left out. */
export function fillEmailBody(template: string, vars: MessageVars): string {
  const values = {
    name: vars.name,
    number: vars.number,
    amount: vars.amount,
    date: vars.date,
    shop: vars.shop,
  };
  return fillHtml(template, values)
    .replace(/\s+([,.])/g, '$1')
    .replace(/\bDear\s*,/g, 'Hello,');
}
